// extracted by mini-css-extract-plugin
module.exports = {"title":"SectionTitle_title__l4wv1","divider":"SectionTitle_divider__BhElB"};